// Password field component
// ========================

import React, { Component } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Label, { SubLabel } from '../../../scentregroup-ui/components/form/label'
import ErrorMessage from '../../../scentregroup-ui/components/form/error-message'
import style from '../../../scentregroup-ui/components/form/textfield.module.scss'
import {
  textfieldPropTypes,
  makeIdString,
} from '../../../scentregroup-ui/components/form/field'

import EyeClosed from './eye-closed.inline.svg?react'
import EyeOpen from './eye-open.inline.svg?react'

export default class PasswordField extends Component {
  fieldId = this.props.id || makeIdString()

  state = {
    value: this.props.value,
    preview: false,
  }

  onChange = (event) => {
    this.setState({ value: event.target.value })

    if (this.props.onChange) {
      this.props.onChange(event)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.value && prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  getPreviewLabel() {
    return this.state.preview ? 'Hide' : 'Show'
  }

  togglePreview = () => {
    this.setState({
      preview: !this.state.preview,
    })
  }

  renderPasswordPreview() {
    const svgProps = {
      className: style.showHideIcon,
    }

    return this.props.preview && this.state.value ? (
      <div className={style.characterCountWrapper}>
        <button
          className={classNames(style.passwordPreview, {
            [style.errorBackground]: this.props.errorMessage,
          })}
          onClick={this.togglePreview}
          type="button"
          aria-label={`${this.getPreviewLabel()} Password`}
        >
          {this.state.preview ? (
            <EyeClosed {...svgProps} />
          ) : (
            <EyeOpen {...svgProps} />
          )}
        </button>
      </div>
    ) : null
  }

  render() {
    const {
      classNames: inputClassNames,
      errorMessage,
      preview,
      label,
      subLabel,
      ariaLabel,
      innerRef,
      ...fieldProps
    } = this.props

    return (
      <div className={classNames(style.Textfield, inputClassNames.wrapper)}>
        <Label
          className={classNames(inputClassNames.label, {
            [style.errorLabel]: errorMessage,
          })}
          for={this.fieldId}
        >
          {label}
        </Label>
        <SubLabel
          className={classNames(inputClassNames.subLabel, {
            [style.errorLabel]: errorMessage,
          })}
        >
          {subLabel}
        </SubLabel>
        <div className={style.fieldIconContainer}>
          <input
            {...fieldProps}
            ref={innerRef}
            type={preview && this.state.preview ? 'text' : 'password'}
            autoComplete="off"
            id={this.fieldId}
            value={this.state.value}
            className={classNames(
              style.field,
              { [style.fieldInvalid]: errorMessage },
              inputClassNames.field
            )}
            aria-label={ariaLabel}
            onChange={this.onChange}
          />
        </div>
        {this.renderPasswordPreview()}
        {errorMessage && (
          <ErrorMessage
            message={errorMessage}
            className={inputClassNames.errorMessage}
          />
        )}
      </div>
    )
  }
}

PasswordField.propTypes = {
  ...textfieldPropTypes,
  preview: PropTypes.bool,
}

PasswordField.defaultProps = {
  classNames: {},
}
